import util from '../util'

let controller = 'ClientSecrets'
export default {
    GetAll: function (dto) {
        return util.Axios.GetAll(controller, dto)
    },
    Post: function (dto) {
        return util.Axios.Post(controller, dto)
    },
    Delete: function (clientId, type, value) {
        let dto = { clientId: clientId, pType: type, pValue: value }
        return util.Axios.DeleteAll(controller , dto)
    },
}